var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreeTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93.71,
    height: 95.099,
    viewBox: "0 0 93.71 95.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Combined_Shape",
    x: 0,
    y: 0,
    width: 93.71,
    height: 95.099,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff8f6b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Combined_Shape)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M26.89,38.925a2.507,2.507,0,0,1-2.507-2.507v-11.7a2.507,2.507,0,0,1,2.507-2.507h7.521a2.507,2.507,0,0,1,2.507,2.507V34.747a4.178,4.178,0,0,1-4.178,4.178Zm-14.876,0a4.177,4.177,0,0,1-4.178-4.178V24.719a2.507,2.507,0,0,1,2.506-2.507h7.52a2.507,2.507,0,0,1,2.507,2.507v11.7a2.507,2.507,0,0,1-2.507,2.507ZM8.244,18.869a2.459,2.459,0,0,1-2.408-2.507V12.184A2.459,2.459,0,0,1,8.244,9.678H18.678L16.5,7.4a2.152,2.152,0,0,1,0-2.957,1.953,1.953,0,0,1,2.841,0l3.347,3.517,3.346-3.517a1.953,1.953,0,0,1,2.841.016,2.153,2.153,0,0,1-.016,2.958L26.7,9.678H37.137a2.459,2.459,0,0,1,2.408,2.507v4.179a2.459,2.459,0,0,1-2.408,2.507Z",
    transform: "translate(24.16 26.17)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeTest);
export default __webpack_public_path__ + "static/media/freeTest.74be45f648051f0b779df7c79ca91a2b.svg";
export { ForwardRef as ReactComponent };